import { ShieldCheck } from "lucide-react";

export function VerifiedShield({ size = "sm", withLabel = false, className = "", testid }) {
  const px = size === "lg" ? "w-6 h-6" : size === "md" ? "w-5 h-5" : "w-4 h-4";
  return (
    <span
      className={`inline-flex items-center gap-1 text-green-600 ${className}`}
      title="Identity verified"
      data-testid={testid || "verified-shield"}
    >
      <ShieldCheck className={`${px} shrink-0`} strokeWidth={2.2} />
      {withLabel && <span className="text-xs font-semibold">Verified</span>}
    </span>
  );
}
